import {RouteConfig} from 'vue-router';

export const homepageRoutes : RouteConfig = {
  path: 'homepage',
  component: () => import('@/views/public/homepage/HomepageView.vue'),
  children: [
    {
      path: '',
      name: 'homepage',
      component: () => import('@/views/public/homepage/index/HomepageIndex.vue'),
    },
  ],
};
